import {Component, OnInit} from '@angular/core';
import {EnvService} from "../services/env.service";

@Component({
  selector: 'micro-swagger',
  templateUrl: './swagger.component.html'
})
export class SwaggerComponent implements OnInit {

  url:string;

  constructor(private env:EnvService) {
  }

  ngOnInit() {
    this.url = `${this.env.e.url}/openapi/ui`;
  }
}
